<template>
    <div class="row" style="margin-top:30px">
        <div class="col-md-12 mb-3">
            <div class="card shadow" :style="{ marginTop: '10px', height: $root.isMobile ? '80px' : '130px' }">
    <div class="card-body d-flex align-items-center">
        <div class="row no-gutters w-100">
            <div v-if="!$root.isMobile" class="col mr-2">
                <div class="font-weight-bold text-ecomm h3 mb-1">
                    Gestionale Energetic Solution {{$root.VERSIONE}}
                </div>
                <div class="h6 mb-0 text-gray-800">
                    <strong>Utente</strong> {{$root.utente.persona.COGNOME}} {{$root.utente.persona.NOME}}
                </div>
                <div class="h6 mb-0 mt-1 text-gray-800">Developed by iSprint</div>
            </div>
            <div v-if="$root.isMobile" class="col text-center">
                <div class="h6 mb-0 text-gray-800">
                    <strong>Utente:</strong> {{$root.utente.persona.COGNOME}} {{$root.utente.persona.NOME}}
                </div>
            </div>
            <div v-if="!$root.isMobile" class="col-auto">
                <img src="~@/assets/Energetic_Logo_3-1024x280.png" style="margin: 0 auto; max-height:80px;" class="img-responsive">
            </div>
        </div>
    </div>
</div>

</div>

        <div class="col-lg-3 col-md-6 col-12" style="height: 140px; margin-bottom: 40px;" v-if="hasFunzionalita(2)">
            <div class="card shadow lift-panel" v-on:click="openModulo('clienti')" style="margin-top:20px;background:#3D519C;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff">Clienti</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci i clienti</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-shopping-cart fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-6 col-12" style="height: 140px;margin-bottom: 40px;" v-if="$root.isGod && hasFunzionalita(3)">
            <div class="card shadow lift-panel" v-on:click="openModulo('contratti')" style="margin-top:20px;background: #127787 !important;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Contratti</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci i contratti</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-file-contract fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-6 col-12" style="height: 140px; margin-bottom: 40px;" v-if="$root.isGod && hasFunzionalita(4)">
            <div class="card shadow lift-panel" v-on:click="openModulo('statistiche')" style="margin-top:20px;background: #48956B!important;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Statistiche</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci le Statistiche</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-analytics fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-6 col-12" style="height: 140px; margin-bottom: 40px;" v-if="$root.isGod && hasFunzionalita(5)">
            <div class="card shadow lift-panel" v-on:click="openModulo('fornitori')" style="margin-top:20px;background: #629991!important;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Fornitori</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci i Fornitori</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-truck fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-6 col-12" style="height: 140px; margin-bottom: 40px;" v-if="$root.isGod && hasFunzionalita(6)">
            <div class="card shadow lift-panel" v-on:click="openModulo('agenti')" style="margin-top:20px;background: #3A524F!important;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Agenti</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci gli Agenti</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-user-secret fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12" style="height: 140px; margin-bottom: 40px;" v-if="$root.isGod && hasFunzionalita(7)">
            <div class="card shadow lift-panel" v-on:click="openModulo('Amministratori')" style="margin-top:20px;background: #7b7158!important;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Amministratori</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci gli Amministratori</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-user-crown fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-6 col-12" style="height: 140px; margin-bottom: 40px;" v-if="$root.isGod && hasFunzionalita(8)">
            <div class="card shadow lift-panel" v-on:click="openModulo('utenti')" style="margin-top:20px;background: #65B7D8 !important;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Utenti</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci gli Utenti</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-users fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-6 col-12" style="height: 140px; margin-bottom: 40px;" v-if="hasFunzionalita(8)">
    <div class="card shadow lift-panel position-relative" v-on:click="openModulo('scadenzari')" style="margin-top:20px;background: #779774 !important;">
        <div class="card-body">
            <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                    <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Scadenzari</div>
                    <div class="h6 mb-0" style="color:#fff">Visualizza e gestisci le Scadenze</div>
                </div>
                <div class="col-auto">
                    <i class="fal fa-calendar-exclamation fa-4x" style="color:#fff"></i>
                </div>
            </div>
            <!-- Badge posizionato nell'angolo in alto a destra -->
            <span v-show="scadenzeVicine > 0" class="badge badge-pill badge-dark position-absolute" 
                  style="top: 10px; right: 10px; font-size: 16px;">
                {{ scadenzeVicine }}
            </span>
        </div>
    </div>
</div>   <!-- <div class="col-3" style="height: 140px; margin-top: 40px;" >
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3" v-on:click="openUpload()" style="margin-top:26px"><i class="fal fa-plus"></i> Carica Flusso</button> 
        </div>
         <div class="modal fade" id="popUpUpload" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:300px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header-success">
                    <h1 style="color:#fff" class="modal-title"><i class="fas fa-file-excel"></i> Carica Flusso</h1>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:390px">
                    <Upload @onsuccess="successCaricamento()" :w="90" :args="args"></Upload>
                </div>
            </div>
        </div>
     </div> -->

    </div>
</template>
<script>

/* import Upload from '@/components/utils/Upload.vue' */

export default {
    name: "Dashboard",
    components: {
/*       Upload */
    },
    data: function () {
        return {
            utente: {},
            tabella: "",
            dataUltimoOrdine: "",
            filters: global.filters,
            args : {modalita:"ES_uploadFlusso"},
            scadenzeVicine:0
        }
    },
    methods: {
        creaTabella: function () {
            utils.ajax('nic/generaclasse', { tabella: this.tabella }, (response) => {

            });
        },
        successCaricamento: function () {
            utils.alert.success("Operazione correttamente eseguita");
            var modal = utils.closeModal('popUpUpload');
        },
        openUpload: function () {
            var modal = utils.openModal('popUpUpload');
        },
        openModulo: function (modulo) {
            global.router.push(modulo);
        },
        hasFunzionalita: function (id) {
            for (var i = 0; i < this.$root.utente.funzionalita.length; i++) {
                if (this.$root.utente.funzionalita[i].ID_FUNZIONALITA == id) {
                    return true;
                }
            }
            return false;
        }
    },
    computed: {

    },
    created: function () {
        global.utils.ajax('core/home',{}, (response) => {            
           this.scadenzeVicine = response.data.SCADENZE_VICINE;
        });
        this.hasFunzionalita()
 

    },
}
</script>